<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="close" v-on:click="close()"></div>
      <div class="modalContent">
        <iframe
          src="https://www.youtube.com/embed/6Mbm1UG2UzY?autoplay=1"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media;
          gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      background-color: #eee;
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .close{
      width: 36px; height: 36px;
      // border-radius: 50%;
      position: absolute;
      right: 20px; top: 20px;
      background-image: url(../assets/close.png);
      background-color: #d5d5d5;
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
      z-index: 91;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-image: url(../assets/close-white.png);
        // background-color: #444;
        // box-shadow: 2px 2px 0 #5351a4;
        background-color: #5351a4;
      }
    }
    .modalContent{
      z-index: 2;
      // border-radius: 10px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      width: 980px;
      line-height: 1;
      background-color: #444;
      // padding: 5px;
      box-shadow: 5px 5px 0 #5351a4;
      @media (max-width: 1024px) {
        width: calc(100% - 20px);
        margin: 0 10px;
        text-align: center;
        padding: 0;
      }
      iframe{
        width: 100%; height: 580px;
        display: block;
        @media (max-width: 1024px) {
          height: 74vw;
        }
      }
    }
  }
</style>
